module.exports = __webpack_public_path__ + "assets/img/teacher (38).fad65efa.png";